var map = {
	"./allinc.png": 26627,
	"./allinclusive.png": 1585,
	"./alpereiser.png": 51348,
	"./amisol.png": 99639,
	"./apollo.png": 45549,
	"./lionalpin.png": 82094,
	"./nazar.png": 50190,
	"./norwegianholidays.png": 3019,
	"./sasholidays.png": 87820,
	"./sembo.png": 25960,
	"./solfaktor.png": 23779,
	"./test.png": 8036,
	"./ticket.png": 88080,
	"./tripx.png": 53211,
	"./tui.png": 57274,
	"./ving.png": 47234,
	"./vingdynamic.png": 43657,
	"./vitalreiser.png": 29320
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62596;